import script from "./AIContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIContent.vue?vue&type=script&lang=ts&setup=true"

import "./AIContent.vue?vue&type=style&index=0&id=7391fd32&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7391fd32"]])

export default __exports__